import { header } from './modules/header';
import { animation } from './modules/animation';

header();
animation();
